import { ConversionUtil } from "@mcleod/core";
import {
    AutogenModelExciseTaxControl, AutogenRowExciseTaxControl, RowExciseTaxControlFields
} from "./autogen/AutogenModelExciseTaxControl";
import { LMEGeneralSettings } from "@mcleod/general";

export class ModelExciseTaxControl extends AutogenModelExciseTaxControl<RowExciseTaxControl> {
	constructor() {
		super(RowExciseTaxControl);
	}
}

export function getExciseTaxControlBoolean(field: keyof RowExciseTaxControlFields, valueIfNull: boolean = false): boolean {
    const result = getExciseTaxControlValue(field);
    if (typeof result === "string")
        return ConversionUtil.parseBoolean(result);
    return result ?? valueIfNull;
}

export function getExciseTaxControlValue(field: keyof RowExciseTaxControlFields): any {
    return LMEGeneralSettings.getSingleton().getExciseTaxControl()[field];
}

export class RowExciseTaxControl extends AutogenRowExciseTaxControl {
}
